
<storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="dataConfig.form" class="formHeight">
    <ul class="list-group">
     <div class="width-33">
      <storever-element-group
        [icon]="'fa-building'"
        [title]="'Subscription (id:' + mySubscription?.id + ')'"
        [config]="dataConfig.groupConfigs.groupConfigs[0].config"
        [form]="dataConfig.form.get(['subscription'])"
        [isEdit]="!(isStatusOff$|async)"
        [status]="(isOrderOpened()|async) ? '1' : '0'"
        [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
        (save)="save(['SubscriptionEditComponent', 'subscription'])"
        (undo)="undo(['subscription'])"
        [stylingClass]="'dynamic-form'">
      </storever-element-group>
    </div>

      <div class="width-33" *ngIf="(servers$|async)?.length">
<!--        {{dataConfig.form.get(['serverForm']).value | json }}-->
        <storever-element-group
          [icon]="'fa-server'"
          [title]="'ORDER_FORM_SERVERS'"
          [config]="dataConfig.groupConfigs.groupConfigs[1].config"
          [form]="dataConfig.form.get(['serverForm'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['SubscriptionEditComponent', 'serverForm'])"
          (undo)="undo(['serverForm'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33" *ngIf="(isServiceVideo$|async)">
        <storever-element-group
          [icon]="'fa-film'"
          [title]="'Options video'"
          [config]="dataConfig.groupConfigs.groupConfigs[2].config"
          [form]="dataConfig.form.get(['videoOption'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['SubscriptionEditComponent', 'videoOption'])"
          (undo)="undo(['videoOption'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33" *ngIf="isConcepts">
        <storever-element-group
          [icon]="'fa-clipboard-list'"
          [title]="'Concepts'"
          [config]="dataConfig.groupConfigs.groupConfigs[5].config"
          [form]="dataConfig.form.get(['concepts'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['SubscriptionEditComponent', 'concepts'])"
          (undo)="undo(['concepts'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>


<!--      <div class="width-25" *ngFor="let elementGroup of dataConfig.elementGroups; let i = index">-->
<!--        <storever-element-group-->
<!--          [icon]="elementGroup.icon"-->
<!--          [title]="elementGroup.title"-->
<!--          [config]="dataConfig.groupConfigs.groupConfigs[i].config"-->
<!--          [form]="dataConfig.form.get(elementGroup.formPath)"-->
<!--          [isEdit]="!(isOrderOpened()|async)"-->
<!--          [status]="'0'"-->
<!--          [paramEdit]="{-->
<!--              text: elementGroup.paramEdit.text,-->
<!--              icon: elementGroup.paramEdit.icon,-->
<!--              type: elementGroup.paramEdit.type,-->
<!--              case: elementGroup.paramEdit.case-->
<!--              }"-->
<!--          (save)="save(elementGroup.savePath)"-->
<!--          (undo)="undo(elementGroup.undoPath)"-->
<!--          [stylingClass]="'dynamic-form'">-->
<!--        </storever-element-group>-->
<!--      </div>-->

    </ul>
  </form>
</ng-template>

<storever-status-to-off #statusToOff></storever-status-to-off>

<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre style="flex: 1 1 0px">site dirty: {{dataConfig?.groupConfigs?.groupConfigs[1]?.config[2]?.presentation|json}}</pre>
  <pre style="flex: 1 1 0px">isStatusOff$: {{(isStatusOff$|async)}}</pre>
  <pre style="flex: 1 1 0px">status presentation: {{dataConfig.groupConfigs.groupConfigs[1].config[2].presentation|json}}</pre>
<!--  <pre style="flex: 1 1 0px">site dirty: {{dataConfig.form.get(['site']).dirty}}</pre>-->
<!--  <pre style="flex: 1 1 0px">subscription dirty: {{dataConfig.form.get(['subscription']).dirty}}</pre>-->
<!--  <pre style="flex: 1 1 0px">serverForm dirty: {{dataConfig.form.get(['serverForm']).dirty}}</pre>-->
<!--  <pre style="flex: 1 1 0px">videoOption dirty: {{dataConfig.form.get(['videoOption']).dirty}}</pre>-->
</div>

